"use client"

import { useQuery } from "@tanstack/react-query"
import { listApiKeysAction, type ApiKeyView } from "@/server-actions/api-keys"

export const apiKeysQueryKey = ["api-keys"] as const

export function useApiKeysQuery() {
  return useQuery<ApiKeyView[]>({
    queryKey: apiKeysQueryKey,
    queryFn: async () => {
      const result = await listApiKeysAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
